import { render } from "./MandateItem.vue?vue&type=template&id=64be436c&scoped=true"
import script from "./MandateItem.vue?vue&type=script&lang=js"
export * from "./MandateItem.vue?vue&type=script&lang=js"

import "./MandateItem.vue?vue&type=style&index=0&id=64be436c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64be436c"]])

export default __exports__